import React from 'react';
import { useAsset } from '../../Asset/Asset';
import Highlight from 'react-highlight.js';
// import 'highlight.js/styles/a11y-dark.css';
// import 'highlight.js/styles/codepen-embed.css';
// import 'highlight.js/styles/github-gist.css';
// import 'highlight.js/styles/hybrid.css';
// import 'highlight.js/styles/railscasts.css';
// import 'highlight.js/styles/monokai-sublime.css';

const CommandWindow = props => {
  const { content, language } = props;
  const asset = useAsset(content);

  return (
    <Highlight language={language}>
      <span
        dangerouslySetInnerHTML={{
          __html: asset.content.replace(/className/g, 'class')
        }}
      />
    </Highlight>
  );
};

export default CommandWindow;
